import React from 'react';
import classnames from 'classnames';

const inputName = (group, name) => {
  if (group === null || group === '') {
    return name;
  }

  return `${group}[${name}]`;
};

const TextInput = (props) => {
  const {
    name,
    value,
    onChange,
    type,
    groupName,
    inputId,
    inputClassName,
    disabled,
    placeholder,
    onBlur,
  } = props;

  return (
    <input
      type={type}
      id={inputId}
      className={classnames('form-control', inputClassName)}
      value={value}
      name={inputName(groupName, name)}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled} />
  );
};

TextInput.defaultProps = {
  type: 'text',
  groupName: 'parameters',
  name: '',
};

export default TextInput;
